import { useEffect } from "react";
import { getConfig } from "@/lib/api";

// Carica dinamicamente Google Tag (gtag.js) per il Google Tag unificato (GT-),
// Google Analytics 4 (G-) e/o Google Ads (AW-), solo se configurati nel pannello
// Admin (Impostazioni). Il Google Tag unificato (GT-) instrada automaticamente
// gli eventi verso le destinazioni collegate (GA4 e Ads).
export const GoogleTag = () => {
  useEffect(() => {
    getConfig()
      .then((c) => {
        const gt = (c.google_tag_id || "").trim();
        const ga = (c.ga4_id || "").trim();
        const ads = (c.google_ads_id || "").trim();
        // Priorita': Google Tag unificato > GA4 > Ads
        const primary = gt || ga || ads;
        if (!primary || window.__gtagLoaded) return;
        window.__gtagLoaded = true;

        const s = document.createElement("script");
        s.async = true;
        s.src = `https://www.googletagmanager.com/gtag/js?id=${primary}`;
        document.head.appendChild(s);

        window.dataLayer = window.dataLayer || [];
        function gtag() { window.dataLayer.push(arguments); }
        window.gtag = gtag;
        gtag("js", new Date());

        // Google Tag unificato: instrada gia' verso GA4/Ads collegati.
        if (gt) gtag("config", gt);
        // Configura GA4 separatamente solo se NON e' presente un Google Tag
        // unificato, per evitare il doppio conteggio delle visualizzazioni.
        if (ga && !gt) gtag("config", ga);
        // Google Ads (tag base per le conversioni esplicite AW-/etichetta).
        if (ads) gtag("config", ads);
      })
      .catch(() => {});
  }, []);
  return null;
};
